import { MAXIMO_POR_BLOQUE, type NotaPublicaCard } from '@ahora-patagonia/contracts';
import { SIZES } from '../../../shared/media/srcset.js';
import { GrillaDeTarjetas } from './GrillaDeTarjetas.js';

export interface PlantillaCuadriculaProps {
  notas: NotaPublicaCard[];
  /** Posición numerada sobre la foto: "Más leídas" también se puede pedir en cuadrícula. */
  numerada?: boolean;
}

/**
 * Plantilla D — la cuadrícula: la misma tarjeta de la tira (foto 16:9 arriba, título abajo), **3 por
 * línea** en escritorio, 2 en tablet y 1 en teléfono. Con 3 columnas fijas en teléfono la foto queda
 * en unos 110 px de ancho, que no es una portada: es un ícono.
 *
 * Lo que la distingue de la tira no son las columnas sino que **no pagina**. Entran todas las notas
 * que el editor pidió —hasta 60, o sea 20 filas— y el lector las recorre scrolleando, sin chevrones
 * ni riel. Por eso no recibe `inicio`: sin páginas, la numeración siempre arranca en 1.
 *
 * El `slice` no es un corte de diseño como el de la tira sino un cinturón: la cantidad ya viene
 * acotada por la API, y si un día llegara de más, es mejor una cuadrícula al tope que una portada de
 * cien notas.
 */
export function PlantillaCuadricula({ notas, numerada = false }: PlantillaCuadriculaProps) {
  return (
    <GrillaDeTarjetas
      notas={notas.slice(0, MAXIMO_POR_BLOQUE.CUADRICULA)}
      columnas={{ xs: 1, sm: 2, lg: 3 }}
      sizes={SIZES.tarjetaCuadricula}
      numerada={numerada}
    />
  );
}
